import { Badge } from '@accure/ui';

export function ResolvedAlertTooltipContent() {
  return (
    <div className="flex gap-2">
      <Badge variant="secondary">Resolved</Badge>
      <div>
        Move card to <b>Done</b> column
      </div>
    </div>
  );
}
